<ng-container *transloco="let t">
  @if (rentPrice()) {
    {{ rentPrice() | currency: 'EUR' : 'symbol' : '1.0-0' }}/m
  } @else {
    @switch (priceType()) {
      @case (PriceType.NONE) {
        {{ t('PRICE_ON_REQUEST') }}
      }
      @case (PriceType.PRICE) {
        {{ price() | currency: 'EUR' : 'symbol' : '1.0-0' }}
      }
    }
  }
</ng-container>
